var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 18C44.5 19.1046 43.6046 20 42.5 20C40.2909 20 38.5 21.7909 38.5 24C38.5 26.2091 40.2909 28 42.5 28C43.6046 28 44.5 28.8954 44.5 30V34C44.5 37.3137 41.8137 40 38.5 40H30.5V34C30.5 32.8954 29.6046 32 28.5 32C27.3954 32 26.5 32.8954 26.5 34V40H10.5C7.18629 40 4.5 37.3137 4.5 34V30C4.5 28.8954 5.39543 28 6.5 28C8.70914 28 10.5 26.2091 10.5 24C10.5 21.7909 8.70914 20 6.5 20C5.39543 20 4.5 19.1046 4.5 18V14C4.5 10.6863 7.18629 8 10.5 8H26.5V14C26.5 15.1046 27.3954 16 28.5 16C29.6046 16 30.5 15.1046 30.5 14V8H38.5C41.8137 8 44.5 10.6863 44.5 14V18ZM28.5 28C29.6046 28 30.5 27.1046 30.5 26V22C30.5 20.8954 29.6046 20 28.5 20C27.3954 20 26.5 20.8954 26.5 22V26C26.5 27.1046 27.3954 28 28.5 28Z",
    fill: "#6B7CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.ff619219ad9043af4089173e2fb6900b.svg";
export { ForwardRef as ReactComponent };